module.exports = __webpack_public_path__ + "img/ecosystem-diagram.af262be0.png";